import {
  Grid,
  Row,
  Column,
  Divider,
  IconChevronLeft,
  SimpleTableWrapper,
  IconButton,
  SimpleTableToolbar,
  CELL_CLASSES,TextRenderer,
  BUTTON_VARIANTS, Toast, TOAST_POSITIONS, TOAST_VARIANTS, TOAST_VISIBILITY_DURATIONS
} from 'cdk-radial';
import {StyledH5, StyledIconErrorCircle} from '../../common/styled';
import {
  StickySimpleTableContainer
} from '../../common/StyledComponents';
import { AgGrid } from '../../common/AgGrid';
import { useHistory, useLocation } from 'react-router-dom';
import { URL_ROUTES } from '../../adapters/constants';
import StatusRenderer from '../../common/StatusRenderer';
import StatusIndicatorLocal from '../../common/StatusIndicatorLocal';
import { useEffect, useState } from 'react';
import moment from 'moment';

export default function PartOrderDetails(): JSX.Element {
   
  const history = useHistory();

  const handleNavigationClick = () => {
    history.push(URL_ROUTES.landingPage);
  };
  const orderData: any = useLocation();  

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [rowData, setRowData] = useState<any[]>([]);  
  
  useEffect(() => {
    if (orderData?.state?.detail) {
      const { oemResponse, parts } = orderData.state.detail;
  
      // Check for transaction messages with return code 99
      const transactionErrorMsg = oemResponse?.transactionMessages?.find(
        (msg: any) => msg.returnedCode !== '00'
      )?.returnedMessage || null;
  
      if (transactionErrorMsg) {
        setToastMessage(transactionErrorMsg); // Set error message for toast
        setShowToast(true); // Show toast
      }
  
      // Check if parts exist directly under detail
      if (parts) {
        const partsErrors = oemResponse?.partsErrors || [];
        const transformedData = parts.map((part: any) => {
          const errors = partsErrors.filter((err: any) => err.partNumber === part.partNumber);
          return {
            ...part,
            errorMessages: errors.map((err: any) => err.returnedMessage),
            vdiflag: part.vdiflag || ''
          };
        });
  
        if (JSON.stringify(rowData) !== JSON.stringify(transformedData)) {
          setRowData(transformedData);
        }
      }
    }
  }, [orderData]);
  
  
  
  

  const headerProps = {
    headerTitle: '',
    hideBorder: false,
    hideTableTitle: false,
    id: `table-header`,
    isAlwaysExpanded: false,
    isDownloadable: false, // Enable CSV download
    isPrintable: false,
    isSearchable: false,
  };

  const columns = [
    { 
      field: 'id', 
      headerName: '#', 
      valueGetter: (params: any) => params.node.rowIndex + 1, 
      width: 80 
    },
    { 
      field: 'partNumber', 
      headerName: 'Part Number', 
      sortable: true, 
      filter: true, 
      flex: 3,
      cellRenderer: (params: any) => {
        const isError = params.data?.errorMessage != null;
        const errorMessages = params.data?.errorMessages || [];
        return (
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center',  // Center vertically
            padding: '4px',            // Reduce padding for less gap
            position: 'relative',      // Ensure error message is positioned correctly
          }}>
            <div style={{ marginBottom: errorMessages ? '-8px' : '0' }}>  {/* Less gap if error exists */}
              {params.value}
            </div>
            {errorMessages.map((msg: string, index: number) => (
              <div key={index} style={{ color: 'red', fontSize: '12px', paddingTop: '2px'}}>
                <StyledIconErrorCircle /> {msg}
              </div>
            ))}
           
           
          </div>
        );
      }
      
    },
    { 
      field: 'description', 
      headerName: 'Description', 
      width: 200
    },
    { 
      field: 'quantity', 
      headerName: 'Quantity', 
      width: 120
    },
    { 
      field: 'price', 
      headerName: 'Price', 
      width: 80, 
      cellStyle: { textAlign: 'right' },
      cellClass: [CELL_CLASSES.ALIGN_CELL_RIGHT, CELL_CLASSES.NUMERIC_CELL],
      cellRenderer: TextRenderer 
    },
    { 
      field: 'serialNumber', 
      headerName: 'Serial Number', 
      width: 180 
    },
    { 
      field: 'vin', 
      headerName: 'VIN', 
      width: 180 
    },
    { 
      field: 'pdc', 
      headerName: 'PDC', 
      width: 80
    },
    { 
      field: 'vdiflag', 
      headerName: 'VDI Flag', 
      width: 80 ,
      valueGetter: (params: any) => params.data?.vdiflag?.trim() === 'X' ? 'Yes' : ''
      
       
    },
    { 
      field: 'transmissionStatus', 
      headerName: 'Transmitted', 
      width: 120, 
      cellRenderer: (params: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <StatusIndicatorLocal status={params.value} /> 
          <span>{params.value}</span>
        </div>
      )
    },
  ];
  
  

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ paddingTop: '15px' }}>
          <IconButton
            data-testid="navigationButton"
            ariaLabel="Account"
            onClick={handleNavigationClick}
            icon={<IconChevronLeft />}
          />
        </div>
        <div>
          <h3>Transmission Details</h3>
        </div>
      </div>
      <Divider style={{opacity:"70%"}} ></Divider>
      <Grid>
        <Row>
          <SimpleTableWrapper
            style={{
              width: '100%'
            }}
          >
            <SimpleTableToolbar>
              <Grid style={{ rowGap: '8px' }}>
                <Row style={{ padding: '0px 0px 8px 0px', height: '20px' }}>
                  <Column l={2} m={12} s={12} xl={2} xs={12}>
                    <StyledH5>Transmission Date and Time </StyledH5>
                  </Column>
                  <Column l={2} m={12} s={12} xl={1} xs={12}>
                    <StyledH5>Transmission</StyledH5>
                  </Column>
                  <Column l={2} m={12} s={12} xl={1} xs={12} style={{marginLeft :"8px"}} >
                    <StyledH5>Processed</StyledH5>
                  </Column>
                </Row>
                <Row style={{ padding: '0px 0px 8px 0px' }}>
                  <Column l={2} m={12} s={12} xl={2} xs={12}>
                    <h5>{moment.utc(orderData.state.detail.createdDate).local().format('YYYY-MM-DD HH:mm:ss')}</h5>
                  </Column>
                  <Column l={1} m={12} s={12} xl={1} xs={12}>
                    <h5> <StatusRenderer subStatus={orderData.state.detail.transmissionStatus} /> </h5>
                  </Column>
                  <Column l={4} m={12} s={12} xl={1} xs={12} style={{marginLeft :"8px"}}>
                    <h5>{orderData.state.detail.processed} </h5>
                  </Column>
                  </Row>
                
                {showToast && toastMessage && (
                    <Row>  
                    <Column xl={12} l={12} m={12} s={12} xs={12}>
                    <Toast
                          content={toastMessage}
                          id="toast-1"
                          onVisibilityDurationEnd={() => setShowToast(true)}
                          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
                          variant ={TOAST_VARIANTS.NEGATIVE}
                        />
                     </Column> </Row>
                    )}
                <Row>
                  <Column l={2} m={12} s={12} xl={2} xs={12}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                      <h4>PO Number {orderData.state.detail.purchaseOrderNumber}</h4>
                    </div>
                  </Column>
                  <Column l={1} m={12} s={12} xl={3} xs={12}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                      <h4>Manual PO Number: {orderData.state.detail.customerPO} </h4>
                    </div>
                  </Column>
                </Row>
              </Grid>
            </SimpleTableToolbar>
            <StickySimpleTableContainer >
            
          <AgGrid
            columns={columns} 
            headerProps={headerProps} 
            rowData={rowData}
            onRowClicked={true}  
            getRowHeight={(params: any) => {
              const errorCount = params.data?.errorMessages?.length || 0;
              return errorCount > 0 ? 48 + errorCount * 16 : 32; // Adjust only when errors exist
            }} 
            dataPageSize={5}
                  
          />
       
            </StickySimpleTableContainer>
          </SimpleTableWrapper>
        </Row>
        <Divider style={{opacity:"70%"}}></Divider>

        <SimpleTableToolbar>
          <Grid>
            <Row style={{ padding: '0px 0px 8px 0px', height: '20px' }}>
                  <Column l={2} m={12} s={12} xl={4} xs={12} style={{marginLeft :'8px'}}>
                <h5>Shipping Preferences</h5>
              </Column>
            </Row>
            <Row style={{ padding: '0px 0px 8px 0px', height: '20px' }}>
                  <Column l={2} m={12} s={12} xl={1} xs={12} style={{marginLeft :'8px'}}>
                <StyledH5>DTNA Order Type</StyledH5>
              </Column>
                  <Column l={2} m={12} s={12} xl={2} xs={12} style={{marginLeft :'8px'}}>
                <StyledH5>Method of Shipping</StyledH5>
              </Column>
                  <Column l={2} m={12} s={12} xl={1} xs={12} style={{marginLeft :'8px'}}>
                <StyledH5>Shipping Notes</StyledH5>
              </Column>
            </Row>
                <Row style={{ padding: '0px 0px 8px 0px',height: '20px'   }}>
                  <Column l={2} m={12} s={12} xl={1} xs={12} style={{marginLeft :'8px'}}>
                <h5>{orderData.state.detail.orderType}</h5>
              </Column>
                  <Column l={2} m={12} s={12} xl={2} xs={12} style={{marginLeft :'8px'}}>           
                <h5> {orderData.state.detail.shippingCond} </h5>
              </Column>
                  <Column l={4} m={12} s={12} xl={1} xs={12} style={{marginLeft :'8px'}}>
                <h5>{orderData.state.detail.orderRefText} </h5>
              </Column>
            </Row>
          </Grid>
        </SimpleTableToolbar>
      </Grid>
    </>
  );
}
